import { render, staticRenderFns } from "./ModalGroup.vue?vue&type=template&id=db7f2d10&scoped=true&"
import script from "./ModalGroup.vue?vue&type=script&lang=js&"
export * from "./ModalGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7f2d10",
  null
  
)

export default component.exports